import { useEffect, useState } from "react";
import Link from "next/link";
import * as analytics from "./analytics";
import getContantPage from "./content";
import { contentType, propsType } from "./types";

const Header = ({ uploadElement }: propsType): JSX.Element => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isNavigation, setIsNavigation] = useState(false);

  const content: contentType = getContantPage();

  useEffect(() => {
    document.addEventListener("scroll", () => {
      setScrollPosition(window.scrollY);
    });
  }, []);

  const headerScroll: string = scrollPosition > 0 ? "header_scroll" : "";
  const headerNavigation: string = isNavigation ? "header_navigation" : "";

  return (
    <header className={`header ${headerScroll} ${headerNavigation}`}>
      <div className="header__container container">
        <Link href="https://retoucher.online/">
          <a className="header__logo" onClick={() => analytics.sendClickLogoMenuEvent()}>
            {content.logo}
          </a>
        </Link>

        <button className="header__navbar" style={{ fontSize: 0 }} onClick={() => { setIsNavigation(!isNavigation) }}>
          {content.menu}
          <i className={isNavigation ? "icon__navbar_hide" : "icon__navbar_show"} />
        </button>

        <nav className={"navigation header__navigation"}>
          <ul className="navigation__list">
            <li className="navigation__list-item" onClick={() => analytics.sendClickHowToMenuEvent()}>
              <a href="https://retoucher.online/how-to">
                {content.instruction}
              </a>
            </li>
            <li className="navigation__list-item">
              <button onClick={() => { analytics.sendClickUpload("header"); uploadElement.current.click() }}>
                {content.upload}
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
